"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BttcConfig = void 0;
const Tokens_1 = require("./Tokens");
const Types_1 = require("../../Types");
const MetamaskConnector_1 = require("../../Connectors/Wallets/MetamaskConnector");
const Utils_1 = require("../Utils");
const MetamaskCompatibleConnector_1 = require("../../Connectors/Wallets/MetamaskCompatibleConnector");
const Factory_1 = require("../../Connectors/Factory");
const WalletConnectConnector_1 = require("../../Connectors/Wallets/WalletConnectConnector");
const CoinbaseConnector_1 = require("../../Connectors/Wallets/CoinbaseConnector");
const TokenPocketConnector_1 = require("../../Connectors/Wallets/TokenPocketConnector");
exports.BttcConfig = Utils_1.blockchainConfigFactory({
    blockchain: Types_1.Blockchains.BTTC,
    chainId: Types_1.EthChainIds.BTTC,
    publicRpc: "https://rpc.bt.io",
    nativeToken: Tokens_1.BTTCNativeToken,
    wrappedToken: Tokens_1.BTTCWrappedToken,
    upToken: Tokens_1.BTTCUpToken,
    logoURI: "https://proxy.unifiprotocol.com/ipfs/QmTrdCwZBPhGSjjFHrZwVBGcSKM2tgdQMiAWuePwhMMR9q",
    multicall: {
        supported: true,
        address: "0x9F80bb4f2eEEdf82d6Cc39c84184E34FC7F198eE",
        tryAggregate: false,
    },
    connectorFactory: Factory_1.web3ConnectorFactory,
    explorer: {
        baseUrl: "https://scan.bt.io",
        address: function (address) {
            return `${this.baseUrl}/#/address/${address}`;
        },
        token: function (address) {
            return `${this.baseUrl}/#/token20/${address}`;
        },
        tx: function (address) {
            return `${this.baseUrl}/#/transaction/${address}`;
        },
    },
}, [
    MetamaskConnector_1.MetamaskConnector,
    TokenPocketConnector_1.TokenPocketConnector,
    MetamaskCompatibleConnector_1.MetamaskCompatibleConnector,
    CoinbaseConnector_1.CoinbaseWalletConnector,
    WalletConnectConnector_1.WalletConnectConnector,
], [
    Factory_1.createWeb3OfflineConnectorHelper(Types_1.OfflineConnectors.BTTC, "https://rpc.bt.io"),
]);
